import Vue from 'vue';
import Highcharts from 'highcharts';
import HighchartsVue from 'highcharts-vue';

import App from './App.vue';
import router from './router';
import store from './store';
import { stackedColumnsBorderRadius } from './js/lib/highcharts-plugins';
import './assets/global.scss';

// To add rounded stack in stacked column graph in Highcharts
// https://stackoverflow.com/questions/52181643/overlapping-and-rounded-stack-in-stacked-column-graph-in-highcharts
stackedColumnsBorderRadius(Highcharts);

Highcharts.setOptions({
  chart: {
    style: {
      fontFamily: '"Helvetica Neue", sans-serif',
    },
  },
  credits: {
    enabled: false,
  },
});

Vue.use(HighchartsVue, {
  tagName: 'charts',
  highcharts: Highcharts,
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
